import useSWR from 'swr';

import { AutomationJobDataType } from '../../../containers/Pages/AdminPage/AutomationView/AutomationJobHistoryView/AutomationJobHistoryTableContainer';
import { PaginatedData, customSWRConfig, customSWRResponse } from '../../../model/types';
import { isValidNumberForRequest } from '../../../utils/validation';
import useSWRCacheKeys from '../../useSWRCacheKeys';

export default function useAutomationJobHistoryById(
    automationId: number,
    page: number,
    config: customSWRConfig = {}
): customSWRResponse<PaginatedData<AutomationJobDataType>> {
    const keys = useSWRCacheKeys(
        isValidNumberForRequest(automationId)
            ? `/automations/definitions/${automationId}/jobs?size=5&page=${page}`
            : null
    );

    return useSWR<PaginatedData<AutomationJobDataType>>(keys, { ...config });
}
